import getRoutes from '@/lib/getRoutes'

const getRouteByLetter = async (letter = ''): Promise<{ href: any; as: any }> => {
  return getRoutes({
    route: 'Brands',
    argsObject: { letter },
  })
}

export default getRouteByLetter
